<template>
  <div>
    <div class="fixed-header">
      <div class="heading">
        <span>
          {{ $t('provider.list.title') }}
        </span>
        <div class="send-buttons">
          <button class="button small warning notif-btn" @click="showNotifModal">Send Notification</button>
          <button class="button small info sms-btn" @click="showSMSModal"><i class="fas fa-comment-dots"></i> Send SMS</button>
          <button class="button small info filter-btn" @click="showFilter" v-if="isMobile"><i class="fas fa-filter"></i></button>
        </div>
      </div>
      <transition name="slide-down">
        <list-filter ref="filter" :isOpen="isOpenFilter" :isMobile="isMobile"></list-filter>
      </transition>
    </div>

    <div :class="{'tables-box':true, 'filterHide':!isOpenFilter}">
      <div v-show="type === 'all' || type === 'tnc'">
        <div class="table-header">
          <div class="table-label">TNC Drivers</div>
          <div class="export-box">
            <!-- <button :class="{'button success xsmall':true, 'disabled':loading}" @click="exportProv('tnc')">EXPORT</button> -->
            <button :class="{'button success xsmall':true, 'disabled':loading || exportLoading.tnc}"
              @click="exportProvInSeries('tnc')" :disabled="loading || exportLoading.tnc">
              <span v-if="exportLoading.tnc">Loading...</span>
              <span v-else>EXPORT</span>
            </button>
          </div>
        </div>
        <list-table target="tnc" class="tables"></list-table>
      </div>

      <div v-show="type === 'all' || type === 'tcp'">
        <div class="table-header">
          <div class="table-label">TCP Drivers</div>
          <div class="export-box">
            <!-- <button :class="{'button success xsmall':true, 'disabled':loading}" @click="exportProv('tcp')">EXPORT</button> -->
            <button :class="{'button success xsmall':true, 'disabled':loading || exportLoading.tcp}"
              @click="exportProvInSeries('tcp')" :disabled="loading || exportLoading.tcp">
              <span v-if="exportLoading.tcp">Loading...</span>
              <span v-else>EXPORT</span>
            </button>
          </div>
        </div>
        <list-table target="tcp" class="tables"></list-table>
      </div>

      <div v-show="type === 'all' || type === 'psc'">
        <div class="table-header">
          <div class="table-label">PSC Drivers</div>
          <div class="export-box">
            <!-- <button :class="{'button success xsmall':true, 'disabled':loading}" @click="exportProv('psc')">EXPORT</button> -->
            <button :class="{'button success xsmall':true, 'disabled':loading || exportLoading.psc}"
              @click="exportProvInSeries('psc')" :disabled="loading || exportLoading.psc">
              <span v-if="exportLoading.psc">Loading...</span>
              <span v-else>EXPORT</span>
            </button>
          </div>
        </div>
        <list-table target="psc" class="tables"></list-table>
      </div>
    </div>

    <notification-modal ref="notif"
      :isList="true" :provId="selected" :showGeofenceOption="true"
      :removeAllActiveUserOption="false" :hideTargetOption="false"
      :showBySector="true"></notification-modal>
    <sms-modal  ref="sms"
      :isList="true" :provId="selected" :showGeofenceOption="true"
      :removeAllActiveUserOption="false" :hideTargetOption="false"></sms-modal>

  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import { Picker } from 'emoji-mart-vue'
import listFilter from './ListFilter'
import listTable from './ListTable'
import ApiProviderList from '@/modules/api/provider/list'
import ApiNotif from '@/modules/api/provider/notifications'
import ApiSMS from '@/modules/api/provider/sms'
import CsvExport from 'csvexport'
import notificationModal from '../App/NotificationModal'
import smsModal from '../App/SMSModal'

const exporter = CsvExport.create({
  filename: 'export.csv',
  columns: [
    'Prov ID', 'Business Name', 'Type', 'Status', 'ADA', 'First Name', 'Last Name',
    'Email', 'Mobile', 'Birthday', 'SSN', 'EIN', 'Address1', 'Address2', 'City', 'State', 'Country',
    'Zip', 'Language', 'Created Date', 'Last Update', 'Vehicle Type', 'Make',
    'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN',
    'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date',
    'TCP Permit #', 'TCP Permit Exp. Date',
    'City License #', 'City License Exp. Date',
    'Airport Permit #', 'Airport Exp. Date',
    'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date',
    'Safety Inspect', 'Last Login Timestamp', 'BG Check',
    'Shared', 'Opoli', 'Black', 'SUV', 'Private Shuttle'
  ]
})

const exporterAll = CsvExport.create({
  filename: 'export.csv',
  columns: [
    'Prov ID', 'Business Name', 'Type', 'Status', 'Service', 'ADA', 'First Name', 'Last Name',
    'Email', 'Mobile', 'Birthday', 'SSN', 'EIN', 'Address1', 'Address2', 'City', 'State', 'Country',
    'Zip', 'Language', 'Created Date', 'Last Update', 'Vehicle Type', 'Make',
    'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN',
    'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date',
    'TCP Permit #', 'TCP Permit Exp. Date',
    'City License #', 'City License Exp. Date',
    'Airport Permit #', 'Airport Exp. Date',
    'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date',
    'Safety Inspect', 'Last Login Timestamp', 'BG Check', 'Services'
  ]
})

export default {
  name: 'providerList',
  data () {
    return {
      selected: [],
      notification: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        isAnnouncement: true,
        loading: false,
        errorMsg: '',
        success: false
      },
      sms: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        // title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        loading: false,
        errorMsg: '',
        success: false
      },
      disableNotifButton: false,
      isMobile: false,
      isOpenFilter: true,
      tempList: {
        tnc: [],
        tcp: [],
        psc: []
      },
      exportLoading: {
        tnc: false,
        tcp: false,
        psc: false
      }
    }
  },
  components: { listFilter, listTable, Picker, notificationModal, smsModal },
  computed: {
    brands () { return this.$store.state.brands.list },
    users () { return this.$store.state.provider.users.list },
    loading () { return this.$store.state.provider.users.isLoading },
    emojiStyle () {
      return { 'width': '100%', 'height': '100%' }
    },
    type () { return this.$store.state.provider.users.type },
    services () { return this.$store.state.services }
  },
  methods: {
    getList () {
      let self = this
      if (self.loading) { return }

      if (self.$refs.filter.refreshTable()) {
        self.$refs.filter.refreshTable()
      }
    },
    expired (date) {
      if (!date || date === 'Invalid date') { return '' }

      let now = moment()
      return moment(date, 'MM/DD/YYYY').diff(now) >= 0 ? '' : 'expired'
    },
    prev () {
      // if (this.currentPage === 1) { return }
      // this.$store.commit('provider/setUserCurrentPage', this.$store.state.provider.users.currentPage - 1)
      // this.getList()
    },
    next () {
      // if (this.isLastPage) { return }
      // this.$store.commit('provider/setUserCurrentPage', this.$store.state.provider.users.currentPage + 1)
      // this.getList()
    },
    sort (field) {
      if (this.loading) { return }
      let prov = this.$store.state.provider.users
      if (field !== prov.order) {
        this.$store.commit('provider/setUserOrderAsc', 1)
      } else {
        this.$store.commit('provider/setUserOrderAsc', prov.orderAsc === 1 ? 0 : 1)
      }
      this.$store.commit('provider/setUserOrder', field)
      // this.$store.commit('provider/setUserCurrentPage', 1)
      // this.getList()
    },
    showFilter () {
      this.isOpenFilter = !this.isOpenFilter 
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    showSMSModal () {
      let self = this
      this.sms.showForm = true
      let provList = this.$store.state.provider.users
      this.selected = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]

      this.$nextTick(() => {
        if (self.$refs.sms.showSMSForm()) {
          self.$refs.sms.showSMSForm()
        }
      })

      // this.sms.target = selected.length ? 'selected' : 'all'
      // this.sms.targetMessage = ''
      // this.sms.messageError = ''
    },
    closeSMSForm () {
      if (this.sms.showEmoji) {
        this.closeEmoji()
        return
      }

      if (this.sms.loading) { return }
      this.sms.showForm = false
      this.sms.brandErrorMsg = ''
      this.sms.errorMsg = ''
      this.sms.success = false
    },
    sendSMS () {
      let self = this

      if (self.validateSmsForm()) { return }

      // let selectedId = self.sms.target === 'all' ? null : self.selected
      let selectedId = null
      if (self.sms.target === 'selected') {
        let provList = this.$store.state.provider.users
        selectedId = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]
      }
      let data = {
        message: self.sms.message,
        contactID: selectedId
      }

      self.sms.brandErrorMsg = ''
      if (self.sms.target === 'all') {
        // if (!self.sms.brand) {
        //   self.sms.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.brandId = self.sms.brand
      }

      self.sms.loading = true
      ApiSMS.send(self, data, function (res) {
        self.sms.loading = false
        self.sms.success = true
        self.sms.message = ''
        self.sms.uploadedUrl = ''
      })
    },
    validateSmsForm () {
      let hasError = false
      this.disableNotifButton = false
      let provList = this.$store.state.provider.users
      this.sms.targetMessage = ''
      if (this.sms.target === 'selected') {
        let selected = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]
        if (!selected.length) {
          hasError = true
        }
        this.sms.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : ''
      }

      this.sms.messageError = ''
      if (this.sms.message === '') {
        hasError = true
        this.sms.messageError = 'This field cannot be empty.'
      }

      return hasError
    },
    showNotifModal () {
      let self = this
      this.notification.showForm = true
      let provList = this.$store.state.provider.users
      this.selected = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]

      this.$nextTick(() => {
        if (self.$refs.notif.showNotifForm()) {
          self.$refs.notif.showNotifForm()
        }
      })
      // this.notification.target = selected.length ? 'selected' : 'all'
      // if (this.notification.target === 'selected') {
      //   this.notification.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : ''
      // }
      // this.notification.titleError = ''
      // this.notification.messageError = ''
    },
    closeNotifForm () {
      if (this.notification.showEmoji) {
        this.closeEmoji()
        return
      }

      if (this.notification.loading) { return }
      this.notification.showForm = false
      this.notification.brandErrorMsg = ''
      this.notification.errorMsg = ''
      this.notification.success = false
    },
    closeEmoji () {
      if (this.notification.showEmoji) {
        this.notification.showEmoji = false
      }
    },
    charCountUpdate () { this.notification.charCount = 180 - (this.notification.message.length) },
    checkFileUpload () {
      let self = this
      if (this.notification.file) {
        let fd = new FormData()
        fd.append('pic', self.notification.file, 'consumer-notif.png')

        self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.notification.uploadedUrl = res.body.data.url
            self.submitNotif()
          }
        })
        return
      }

      self.submitNotif()
    },
    submitNotif () {
      let self = this
      // let selectedId = self.notification.target === 'all' ? null : self.selected

      if (self.validateNotifForm()) { return }

      let selectedId = null
      if (self.notification.target === 'selected') {
        let provList = this.$store.state.provider.users
        selectedId = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]
      }
      let data = {
        title: self.notification.title,
        message: self.notification.message,
        // image: self.notification.uploadedUrl,
        contactID: selectedId,
        announcement: self.notification.isAnnouncement
      }

      self.notification.brandErrorMsg = ''
      if (self.notification.target === 'all') {
        // if (!self.notification.brand) {
        //   self.notification.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.brandId = self.notification.brand
      }

      self.notification.loading = true
      if (self.notification.isAnnouncement) {
        let announcement = {
          title: self.notification.title,
          message: self.notification.message,
        }
        ApiNotif.sendAnnouncement(self, announcement, function (res) {
          self.notification.isAnnouncement = false
        })
      }
      ApiNotif.send(self, data, function (res) {
        self.notification.loading = false
        self.notification.success = true
        self.notification.title = ''
        self.notification.message = ''
        self.notification.uploadedUrl = ''
        // self.cleanFileInput()
      })
    },
    addEmoji (emoji) {
      this.notification.showEmoji = false

      let textarea = this.$refs.notifMsg
      let cursorPosition = textarea.selectionEnd
      let start = this.notification.message.substring(0, textarea.selectionStart)
      let end = this.notification.message.substring(textarea.selectionStart)
      let text = start + emoji.native + end
      this.notification.message = text
      textarea.focus()
      let self = this
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.native.length
        self.charCountUpdate()
      })
    },
    exportProv (target) {
      let self = this
      ApiProviderList.export(self, target, function (res) {
        if (!res.error) {
          exporterAll.downloadCsv(res)
        }
      })
    },
    exportProvAll (target) {
      let self = this
      ApiProviderList.exportAll(self, target, function (res) {
        if (!res.error) {
          exporterAll.downloadCsv(res)
        }
      })
    },
    exportProvInSeries (target, page = 1) {
      let self = this
      if (page == 1) {
        self.tempList[target] = []
      }
      let providers = self.$store.state.provider.users
      let params = {
        token: self.$store.state.session.sessionToken,
        status: providers.status,
        license: target,
        pageNum: page,
        pageSize: 200,
        paging: 1,
      }
      if (providers.serviceFilter === 'PAX') {
        params.isPax = 1
        params.isDTD = 0
      }
      if (providers.serviceFilter === 'DTD') {
        params.isPax = 0
        params.isDTD = 1
      }
      if (providers.serviceFilter === 'PAX/DTD') {
        params.isPax = 1
        params.isDTD = 1
      }
      self.exportLoading[target] = true
      self.$sdk.get('/provider/export', params, res => {
        if (!res.error) {
          if (res.list.length) {
            res.list.forEach(function (value) {
              self.tempList[target].push(self.buildExportAll(value))
            })
          }
          if ((page * res.paging.pageSize) < res.paging.totalItems) {
            self.exportProvInSeries(target, page + 1)
          } else {
            self.exportLoading[target] = false
            exporterAll.downloadCsv(self.tempList[target])
          }
        }
      })
    },
    buildExportAll (data) {
      let licenseType = ''
      if (data.licenseType) {
        licenseType = data.licenseType.toUpperCase()
      }

      let bday = ''
      if (data.dateOfBirth) {
        let temp = moment(data.dateOfBirth, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          bday = temp.format('MM/DD/YYYY')
        }
      }

      let created = ''
      if (data.created) {
        let temp = moment(data.created, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          created = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let modified = ''
      if (data.modified) {
        let temp = moment(data.modified, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          modified = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let insurance = ''
      if (data.insurancePolicyExp) {
        let temp = moment(data.insurancePolicyExp, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          insurance = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let permit = ''
      if (data.tcpPermitExp) {
        let temp = moment(data.tcpPermitExp, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          permit = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let cityLicense = ''
      if (data.cityLicenseExp) {
        let temp = moment(data.cityLicenseExp, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          cityLicense = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let airport = ''
      if (data.airportPermitExp) {
        let temp = moment(data.airportPermitExp, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          airport = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let license = ''
      if (data.driverLicenseExp) {
        let temp = moment(data.driverLicenseExp, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          license = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let drivingRecordExp = ''
      if (data.drivingRecordExp) {
        let temp = moment(data.drivingRecordExp, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          drivingRecordExp = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let safetyInspect = ''
      if (data.vehicleSafetyInspectionByExp) {
        let temp = moment(data.vehicleSafetyInspectionByExp, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          safetyInspect = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let lastLogin = '--'
      if (data.lastDuty) {
        // let temp = moment(data.lastLogin, 'YYYY-MM-DD HH:mm:ss')
        let temp = moment(data.lastDuty, 'YYYY-MM-DD HH:mm:ss')
        if (temp.isValid()) {
          lastLogin = temp.format('MM/DD/YYYY HH:mm:ss')
        }
      }

      let service = ''
      if (data.isPax) { service = 'PAX' }
      if (data.isDTD) { service = 'DTD' }
      if (data.isPax && data.isDTD) { service = 'PAX/DTD' }

      
      return {
        'Prov ID': data.ID,
        'Business Name': data.businessName || '',
        'Type': licenseType,
        'Status': data.duty || 'a',
        'Service': service,
        'ADA': data.wheelChairLift ? 'YES' : 'NO',
        'First Name': data.firstName,
        'Last Name': data.lastName,
        'Email': data.email,
        'Mobile': data.phoneNumber,
        'Birthday': bday,
        'SSN': data.businessSSN || '',
        'EIN': data.businessEIN || '',
        'Address1': data.addressLine1 || '',
        'Address2': data.addressLine2 || '',
        'City': data.city,
        'State': data.state,
        'Country': data.country,
        'Zip': data.zipCode,
        'Language': data.language || 'english',
        'Created Date': created,
        'Last Update': modified,
        'Vehicle Type': data.vehicleType || '',
        'Make': data.make || '',
        'Model': data.model || '',
        'Year': data.makeYear || '',
        'License Plate': data.licensePlate || '',
        'Seat Capacity': data.seatCapacity,
        'VIN': data.vehicleIdNumber || '',
        'Insurance Company Name': data.insuranceCompany || '',
        'Insurance Policy #': data.insurancePolicyNumber || '',
        'Insurance Exp. Date': insurance,
        'TCP Permit #': data.tcpPermitNumber || '',
        'TCP Permit Exp. Date': permit,
        'City License #': data.cityLicenseNumber || '',
        'City License Exp. Date': cityLicense,
        'Airport Permit #': data.airportPermitNumber || '',
        'Airport Exp. Date': airport,
        'Driver\'s License #': data.driverLicenseNumber || '',
        'Driver\'s License Exp. Date': license,
        'Driving Record Exp. Date': drivingRecordExp,
        'Safety Inspect': safetyInspect,
        'Last Login Timestamp': lastLogin,
        'BG Check': data.backgroundCheckPassed !== 0,
        'Services': data.serviceTypeNames || ''
        // 'Shared': shared,
        // 'Opoli': opoli,
        // 'Black': black,
        // 'SUV': suv,
        // 'Private Shuttle': shuttle
      }
    },
    validateNotifForm () {
      let hasError = false
      this.disableNotifButton = false
      let provList = this.$store.state.provider.users

      this.notification.targetMessage = ''
      if (this.notification.target === 'selected') {
        let selected = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]
        if (!selected.length) {
          hasError = true
        }
        this.notification.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : ''
      }

      this.notification.titleError = ''
      if (this.notification.title === '') {
        hasError = true
        this.notification.titleError = 'This field cannot be empty.'
      }

      this.notification.messageError = ''
      if (this.notification.message === '') {
        hasError = true
        this.notification.messageError = 'This field cannot be empty.'
      }

      return hasError
    }
  },
  watch: {
    loading (value) { this.selected = [] },
    // selected (value) { this.$store.commit('provider/setUserSelected', value) },
    'notification.target' (value) {
      this.disableNotifButton = false
      let provList = this.$store.state.provider.users

      this.notification.targetMessage = ''
      if (value === 'selected') {
        let selected = [...provList.tnc.selectedUser, ...provList.tcp.selectedUser, ...provList.psc.selectedUser]
        // this.disableNotifButton = selected.length === 0
        this.notification.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : ''
      }
    },
    'services.serviceLoading' (value) {
      if (!value) {
        // this.getList()
      }
    }
  },
  mounted () {
    let self = this

    self.setScreenSize()
    self.$store.commit('provider/setUserCurrentPage', {target: 'tnc', value: 1})
    self.$store.commit('provider/setUserCurrentPage', {target: 'tcp', value: 1})
    self.$store.commit('provider/setUserCurrentPage', {target: 'psc', value: 1})
    self.getList() // load service list first

    if (self.$store.state.brands.list.length === 0) {
      self.$store.commit('brands/setLoading', true)
      self.$sdk.get('/brand', {}, res => {
        self.$store.commit('brands/setLoading', false)
        let brands = []
        res.forEach(function (data) {
          brands.push({ id: data.id, name: data.name })
        })
        self.$store.commit('brands/setList', brands)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 155px;
}
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
}
.notif-btn, .sms-btn, .filter-btn{
  margin: 7px 10px;
}

.sms-btn {
  background-color: #16b0de;
}

.filter-btn {
  background-color: gray;
}

.tables-box{
  margin-top: 153px;
  padding: 30px 40px;
  height: calc(100vh - 153px);
  overflow: auto;

  .table-label{
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    padding-left: 5px;
    display:inline-block
  }
  .tables{ margin-bottom: 50px; }
  .table-header{
    background: #4a4a4a;
    margin-bottom: 5px;
    padding: 5px;

    .export-box{
      float: right;
      padding: 4px 10px 0 0;
      .success{ margin-right: 5px; }
    }
  }
}

.sticky{
  position: fixed;
  top: 153px;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 50px;
  z-index: 3;

  tbody{ visibility: hidden; }
}

.main-table{ margin: 153px 0 70px; }
table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
    &.psc{ background: #de6c2a; }
  }
  .status{ text-transform: capitalize; }
  .expired{ color: #de2929; }
  .fa-check-circle{ color: #0fda4e; }
  .fa-times-circle{ color: #ef3535; }
  a{ cursor: pointer; }
  .date{ word-spacing: 5px; }
}

.announcement-check{
  margin-bottom: 5px!important;
  padding-left: 2px;
}
input[type="checkbox"]{
  width: auto;
  margin-top: 0;
}

.fix-footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{ max-width: 100px; }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 15px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 15px 0;
  }
  .pagination{
    text-align: right;
    padding: 15px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.data-field{
  position: relative;
  margin-bottom: 20px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 3px;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 5px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }

  select{
    border: 1px solid #ddd;
    padding: 5px 10px;
    color: #333;
    height: 35px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}

.notification-form{
  background-color: #fff;
  max-width: 400px;
  margin: 10px auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  .header{
    background: #333;
    color: #fff;
    padding: 10px;
    font-size: 18px;
    text-align: center;
  }

  .nf-content{
    padding: 20px;
    position: relative;

    .label{
      font-size: 13px;
      color: #555;
    }
    label{
      display: block;
      font-size: 14px;
      color: #555;
      margin-bottom: 2px;
      cursor: pointer;

      input{
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .textarea-box{
      position: relative;
      margin-bottom: 15px;
      padding-bottom: 20px;

      .emoji-trigger{
        position: absolute;
        top: 133px;
        right: 0;
        color: #aaa;
        cursor: pointer;
      }
      .error-msg{
        font-size: 11px;
        line-height: 1.6;
        color: #f20d0d;
        font-style: italic;
        display: block;
      }
    }
    textarea{
      margin: 0;
      padding: 10px;
      width: 100%;
      resize: none;
      background: #fdfdfd;
      font-size: 14px;
      outline: none;
      color: #333;
      border-color: #ddd;
      box-shadow: 1px 1px 3px rgba(0,0,0, .05) inset;
      transition: all .3s ease;

      &.exceed{
        border-color: #d61613;
        background: #fff0f0;
      }
    }
    .char-count{
      font-size: 12px;
      color: #777;
      display: block;
      text-align: right;
      line-height: 1;
      margin-top: 5px;

      &.exceed{ color:#f00; }
    }
    .cancel-notif{
      display: block;
      font-size: 13px;
      margin: 10px 0 0;
      text-align: center;
      cursor: pointer;
      color: #bbb;
      transition: all .5s ease;
      &:hover{ color:#333; }
    }
    .file-box{
      position: relative;

      input{
        padding: 5px 25px 5px 5px;
        margin:0;
        font-size: 14px;
      }
      i{
        position: absolute;
        z-index: 2;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: #fd4a38;
        cursor: pointer;
      }
    }
  }

  .error{
    text-align: center;
    i{ color:#fd4a38; }
    p{ margin: 5px 0 20px; }
    code{
      border:2px solid #fd4a38;
      padding: 10px;
      width: 100%;
      display: block;
      font-size: 14px;
      background: #ffeeec;
      border-radius: 3px;
      margin-bottom: 30px;
    }
  }

  .success-box{
    text-align: center;
    i{ color: #26d97a; }
  }

  .loader{
    position: absolute;
    top:0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);

    div{
      position: absolute;
      top:50%;
      left: 0;
      height: 50px;
      width: 100%;
      transform: translateY(-50%);
      text-align: center;

      i{ color: #45e7f9; }
      span{
        color: #fff;
        font-size: 21px;
        font-weight: 600;
        margin-left: 5px;
        text-shadow: 1px 1px 1px rgba(0,0,0, .4);
      }
    }
  }
}
.emoji-box{
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter,
.slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}


.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.2s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}

.pop-enter-active, .pop-leave-active { transition: all .3s ease; }
.pop-enter, .pop-leave-to {
  transform: scale(.8);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .fixed-header {
    position: absolute;
    height: 0;
  }
  .heading {
    flex-direction: column;
    .send-buttons {
      margin-left: -60px;
      display: flex;
      justify-content: center;
    }
  }
  .small-3 {
    width: 100%;
  }

  .tables-box {
    margin-top: 330px;
    z-index: 1;
    padding: 10px;
    .table {
      margin-bottom: 30px;
    }
    .table-header .export-box .success {
      margin-right: 0;
    }
    &.filterHide {
      margin-top: 190px;
      height: calc(100vh - 190px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/List.vue